import { LanguageAnnotation } from 'dibs-buyer-layout/exports/types/dblRouteConfig';
import { graphql, readInlineData } from 'relay-runtime';

import { getLanguageAnnotations_pdpMetaItems$key } from './__generated__/getLanguageAnnotations_pdpMetaItems.graphql';
import { filterFalsy } from 'dibs-ts-utils/src/filterFalsy';

type Props = {
    pdpMetaItems: getLanguageAnnotations_pdpMetaItems$key | null | undefined;
    localeOrigin: string;
};

export const getLanguageAnnotations = ({
    localeOrigin,
    pdpMetaItems: pdpMetaItemsRef,
}: Props): LanguageAnnotation[] => {
    const pdpMetaItems = readInlineData(
        graphql`
            fragment getLanguageAnnotations_pdpMetaItems on pdpMetaItems @inline {
                languageAnnotations {
                    hrefLang
                    href
                }
            }
        `,
        pdpMetaItemsRef
    );

    return (pdpMetaItems?.languageAnnotations || [])
        .filter(filterFalsy)
        .reduce((annotations, { href, hrefLang }) => {
            if (hrefLang && typeof hrefLang === 'string' && href && typeof href === 'string') {
                annotations.push({
                    rel: 'alternate',
                    hrefLang: hrefLang,
                    href: `https://${localeOrigin}${href}`,
                });
            }
            return annotations;
        }, [] as LanguageAnnotation[]);
};
